import moment from "moment";
import sweetAlert from "sweetalert2/dist/sweetalert2.min";

export default class SweetAlertService {
  /* @ngInject */
  constructor($rootScope, $filter, Utils, $q, errorMessages) {
    this.$rootScope = $rootScope;
    this.$filter = $filter;
    this.Utils = Utils;
    this.$q = $q;
    this.cardErrors = errorMessages.cardErrors;
  }

  quoteExchangeRatesUpdated() {
    sweetAlert(
      this.$filter("trans")("sweetAlert.quoteExchangeRatesUpdated.title"),
      this.$filter("trans")("sweetAlert.quoteExchangeRatesUpdated.text"),
      "success",
    )
      .then(() => true)
      .catch(() => false);
  }

  howUpdateQuote(costCurrencies, ratiosTable) {
    return this.$q((resolve, reject) => {
      sweetAlert({
        title: this.$filter("trans")("sweetAlert.howUpdateQuote.title"),
        html: this.$filter("trans")("sweetAlert.howUpdateQuote.text", [costCurrencies, ratiosTable]),
        type: "question",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$filter("trans")("sweetAlert.howUpdateQuote.confirmButtonText"),
        cancelButtonText: this.$filter("trans")("sweetAlert.howUpdateQuote.cancelButtonText"),
        cancelButtonClass: "swal2-confirm",
      })
        .then(() => resolve("keep-price"))
        .catch((cause) => {
          if (cause === "cancel") resolve("keep-margin");
          else resolve(false);
        });
    });
  }

  wantRemoveQuote() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      text: this.$filter("trans")("sweetAlert.wantRemoveQuote.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  wantRemoveInvitation(email, organizationName) {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      html: this.$filter("trans")("sweetAlert.wantRemoveInvitation.text", [email, organizationName]),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  wantRemoveTariff() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      html: this.$filter("trans")("sweetAlert.wantRemoveTariff.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  wantRemoveSection() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      html: this.$filter("trans")("sweetAlert.wantRemoveSection.text"),
      // type: 'warning',
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  invitationRemoved() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.congratulations"),
      text: this.$filter("trans")("sweetAlert.invitationRemoved.text"),
      type: "success",
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.ok"),
      showCloseButton: true,
    })
      .then(() => true)
      .catch(() => false);
  }

  userRemoved() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.congratulations"),
      text: this.$filter("trans")("sweetAlert.userRemoved.text"),
      type: "success",
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.ok"),
      showCloseButton: true,
    })
      .then(() => true)
      .catch(() => false);
  }

  wantRemoveUser(userName, organizationName) {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      html: this.$filter("trans")("sweetAlert.wantRemoveUser.text", [userName, organizationName]),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  tariffPricesUpdated() {
    sweetAlert(
      this.$filter("trans")("sweetAlert.tariffPricesUpdated.title"),
      this.$filter("trans")("sweetAlert.tariffPricesUpdated.text"),
      "success",
    )
      .then(() => true)
      .catch(() => false);
  }

  updateTariffPrices() {
    return this.$q((resolve) => {
      return sweetAlert({
        title: this.$filter("trans")("sweetAlert.updateTariffPrices.title"),
        text: this.$filter("trans")("sweetAlert.updateTariffPrices.text"),
        type: "question",
        showCancelButton: true,
        confirmButtonText: this.$filter("trans")("sweetAlert.updateTariffPrices.confirmButtonText"),
        cancelButtonText: this.$filter("trans")("sweetAlert.updateTariffPrices.cancelButtonText"),
      })
        .then(() => resolve("update-tariffs"))
        .catch((cause) => (cause === "cancel" ? resolve("no-update-tariffs") : resolve(false)));
    });
  }

  templateWillBeDeleted() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      text: this.$filter("trans")("sweetAlert.templateWillBeDeleted.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  contactWillBeDeleted() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      text: this.$filter("trans")("sweetAlert.contactWillBeDeleted.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  costAssociatedToTariffs() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      text: this.$filter("trans")("sweetAlert.costAssociatedToTariffs.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  canHaveAssociatedTariffs() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.common.title.areYouSure"),
      text: this.$filter("trans")("sweetAlert.canHaveAssociatedTariffs.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.delete"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  resetedPassword(email) {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.resetedPassword.title"),
      text: this.$filter("trans")("sweetAlert.resetedPassword.text", [email]),
      type: "success",
    })
      .then(() => true)
      .catch(() => false);
  }

  errorResetingPassword() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.errorResetingPassword.title"),
      text: this.$filter("trans")("sweetAlert.errorResetingPassword.text"),
      type: "error",
    })
      .then(() => true)
      .catch(() => false);
  }

  processingRequest() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.processingRequest.title"),
      text: this.$filter("trans")("sweetAlert.processingRequest.text"),
      showConfirmButton: false,
      allowOutsideClick: false,
    })
      .then(() => true)
      .catch(() => false);
  }

  loadingQuoteEditor() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.loadingQuoteEditor.title"),
      text: this.$filter("trans")("sweetAlert.loadingQuoteEditor.text"),
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
      .then(() => true)
      .catch(() => false);
  }

  generatingPdf() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.generatingPdf.title"),
      text: this.$filter("trans")("sweetAlert.generatingPdf.text"),
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
      .then(() => true)
      .catch(() => false);
  }

  confirmationRequestDefaultDomain() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.confirmationRequestDefaultDomain.title"),
      html: this.$filter("trans")("sweetAlert.confirmationRequestDefaultDomain.text", [process.env.PROPOSAL_URL]),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.agree"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  confirmationRequestCustomDomain() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.confirmationRequestCustomDomain.title"),
      html: this.$filter("trans")("sweetAlert.confirmationRequestCustomDomain.text", [process.env.PROPOSAL_URL]),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.agree"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  confirmationOverWriteQuoteTemplate() {
    return sweetAlert({
      title: this.$filter("trans")("sweetAlert.confirmationOverWriteQuoteTemplate.title"),
      text: this.$filter("trans")("sweetAlert.confirmationOverWriteQuoteTemplate.text"),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.agree"),
      cancelButtonText: this.$filter("trans")("sweetAlert.common.cancelButtonText.cancel"),
    })
      .then(() => true)
      .catch(() => false);
  }

  successfullyRequestedDefaultDomain() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.successfullyRequestedDefaultDomain.title"),
      text: this.$filter("trans")("sweetAlert.successfullyRequestedDefaultDomain.text"),
      type: "success",
      confirmButtonText: this.$filter("trans")("sweetAlert.common.confirmButtonText.ok"),
      showCloseButton: true,
    })
      .then(() => true)
      .catch(() => false);
  }

  pasteImageLoader() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.pasteImageLoader.title"),
      text: this.$filter("trans")("sweetAlert.pasteImageLoader.text"),
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
      .then(() => true)
      .catch(() => false);
  }

  failedPasteImageMaxSize() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.failedPasteImageMaxSize.title"),
      text: this.$filter("trans")("sweetAlert.failedPasteImageMaxSize.text"),
      type: "error",
    })
      .then(() => true)
      .catch(() => false);
  }

  failedPasteImageUpload() {
    sweetAlert({
      title: this.$filter("trans")("sweetAlert.failedPasteImageUpload.title"),
      text: this.$filter("trans")("sweetAlert.failedPasteImageUpload.text"),
      type: "error",
    })
      .then(() => true)
      .catch(() => false);
  }

  close() {
    sweetAlert.close();
  }
}
